module.exports = __webpack_public_path__ + "font_anzu.89297a52.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/font_anzu.png
// module id = PaJJ
// module chunks = 0